import { Modal, Select } from 'antd';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { IAcaoEmLoteDTO, IContaCleanDTO } from '../../../models/happy-code-api.model';
import BaseInput from './base-input';
import Styles from './components.module.scss';
import { useContaService } from '../../../services/conta.service';
import { Predicate } from '../../../models/predicate.model';
import BaseSelect from './base-select';

interface ModalAlterarContaProps {
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	acaoEmLote: IAcaoEmLoteDTO;
	setAcaoEmLote: Dispatch<SetStateAction<IAcaoEmLoteDTO>>;
	handleAction: (value: any) => void;
}

export default function ModalAlterarConta({ open, setOpen, acaoEmLote, setAcaoEmLote, handleAction }: ModalAlterarContaProps) {
	const [contaList, setContaList] = useState<IContaCleanDTO[]>([]);
	const contaService = useContaService();

	useEffect(() => {
		const getContas = async () => {
			const predicate = new Predicate();
			predicate.addOption('ativo', true);
			const response = await contaService.findCleanList(predicate);
			setContaList(response.data);
		}
		getContas();
	},[])
	const handleOk = () => {
		handleAction('ALTERAR_CONTA');
		setOpen(false);
	};
	return (
		<Modal
			destroyOnClose
			style={{ top: 20 }}
			title="Alterar Conta"
			visible={open}
			onOk={() => handleOk()}
			onCancel={() => setOpen(false)}
			okText="Alterar Conta"
			cancelText="Cancelar"
		>
			<div className={Styles.modalContainer}>
				<BaseSelect
					labelConfig={{ label: 'Conta', required: true }}
					width={'60%'}
					value={acaoEmLote?.idConta}
					onChange={(e) => setAcaoEmLote({ ...acaoEmLote, idConta: e })}
					>
						{contaList?.map((conta) => (
							<Select.Option key={conta.id} value={conta.id}>
								{conta.descricao}
							</Select.Option>
						))}
					</BaseSelect>
			</div>
		</Modal>
	);
}
